import trimRangeByAnotherRange from "./trimRangeByAnotherRange";
export default function zeroSubrangeByContainerRange(subRange, containerRange, sequenceLength) {
  const trimmedSubRange = trimRangeByAnotherRange(
    subRange,
    containerRange,
    sequenceLength
  );
  if (trimmedSubRange) {
    throw new Error(
      "subRange must be fully contained by containerRange! Otherwise this function does not make sense"
    );
  }
  const newSubrange = {};
  newSubrange.start = subRange.start - containerRange.start;
  newSubrange.end = subRange.end - containerRange.start;
  if (newSubrange.start < 0) {
    newSubrange.start += sequenceLength;
  }
  if (newSubrange.end < 0) {
    newSubrange.end += sequenceLength;
  }
  return newSubrange;
}
